import React from 'react'

function TdElement(selectedIndex: SelectIndex,
    children: JSX.Element | string | number, indent: boolean = false, sticky: boolean = false, stickToRight: boolean = false) {
    return (
        <td className={`table-item-style tw-truncate tw-z-10 ${indent ? "tw-pl-2" : ""} ${selectedIndex.defaultIndex as number % 2 === 0 ?
            "tw-bg-white" : "tw-bg-[#F4F5F7]"} ${sticky ? "tw-sticky tw-left-0" : ""} ${stickToRight ? "tw-sticky tw-right-0" : ""} `} >
            {children}
        </td>
    )
}

export default TdElement